/*eslint-disable*/
import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/procedimiento`;
const readUrl = (url = "") => `${urlBase}${url}`;

export const fetchProcedimiento = async (params) => {
  const auth = `Bearer ${getToken()}`;
  const query = new URLSearchParams(params);
  let res = await fetch(readUrl(`/${params}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);
  return res.success;
};
export const patchProcedimiento = async (clientId, body) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`/${clientId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      title: body.title,
      members: body.members,
      operacion: body.operacion,
      particularidades: body.particularidades,
      nomina: body.nomina,
      facturacion: body.facturacion,
      cobranzas: body.cobranzas,
      otrasAreas: body.otrasAreas,
      id: body.id,
    }),
  });

  res = await parseJSON(res);

  return res.success;
};
export const postProcedimiento = async (clientId, body) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(urlBase, {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      title: body.title,
      members: body.members,
      operacion: body.operacion,
      particularidades: body.particularidades,
      nomina: body.nomina,
      facturacion: body.facturacion,
      cobranzas: body.cobranzas,
      otrasAreas: body.otrasAreas,
      clientId: clientId,
    }),
  });

  res = await parseJSON(res);

  return res.success;
};
export const postProcedimientoPdf = async (id) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(`${urlBase}/pdf/${id}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};
